import { OverlayTrigger, Tooltip } from "react-bootstrap";

export default function OverlayTriggerTooltip({
  tooltipId = "",
  tooltipText = "",
  placement = "auto",
  triggerEl,
}) {
  return (
    <OverlayTrigger
      placement={placement}
      overlay={(props) => (
        <Tooltip id={tooltipId} {...props}>
          {tooltipText}
        </Tooltip>
      )}
    >
      {triggerEl}
      {/* <span className={textClass}>{text}</span> */}
    </OverlayTrigger>
  );
}
